module.exports = __webpack_public_path__ + "img/val-manage.2664052f.png";